import { create } from 'zustand';
import ResponseError from '../../types/response/ResponseError';
import { CancelTokenSource } from 'axios';
import { PagingResponseData } from '../../types/response/PagingResponseData';
import { Organization } from '../../types/b2b/Organization';

export interface B2BStore {
    isAddingBuyer: boolean;
    error?: ResponseError;
    isFailed: boolean;
    isAddBuyerSucceeded: boolean;
    isSearching: boolean;
    isCanceled: boolean;
    searchCancelToken: CancelTokenSource;
    searchResult: PagingResponseData<Organization[]>;
    addBuyerStarted: () => void;
    addBuyerSucceeded: () => void;
    addBuyerFailed: (error: ResponseError) => void;
    searchStarted: (requestParameters: string, cancelToken: CancelTokenSource) => void;
    searchFailed: (error: ResponseError) => void;
    searchSucceeded: (data: PagingResponseData<Organization[]>) => void;
    searchCanceled: () => void;
    reset: () => void;
}

export const initialState = {
    isAddingBuyer: false,
    isAddBuyerSucceeded: false,
    error: undefined,
    isCanceled: false,
    searchResult: {} as PagingResponseData<Organization[]>,
    isSearching: false,
    isFailed: false,
    requestParameters: '',
    searchCancelToken: {} as CancelTokenSource,
    exactSearch: false,
};

export const useB2BStore = create<B2BStore>(set => ({
    ...initialState,

    addBuyerStarted: () =>
        set({
            isAddingBuyer: true,
            error: undefined,
            isAddBuyerSucceeded: false,
        }),

    addBuyerSucceeded: () =>
        set({
            isAddingBuyer: false,
            isAddBuyerSucceeded: true,
        }),

    addBuyerFailed: (error: ResponseError) =>
        set({
            isAddingBuyer: false,
            error: error,
        }),

    searchStarted: (requestParameters: string, cancelToken: CancelTokenSource) =>
        set({
            isSearching: true,
            isCanceled: false,
            searchCancelToken: cancelToken,
        }),

    searchFailed: (error: ResponseError) =>
        set({
            error: error,
            isSearching: false,
            isCanceled: false,
            isFailed: true,
            searchResult: {} as PagingResponseData<Organization[]>,
        }),

    searchSucceeded: (data: PagingResponseData<Organization[]>) =>
        set({
            searchResult: { ...data },
            isCanceled: false,
            isSearching: false,
            isFailed: false,
        }),

    searchCanceled: () =>
        set({
            isCanceled: true,
        }),

    reset: () => set(initialState),
}));
